import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|System Activity|Merges|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.MergeCandidates,
	portal: 'SP',
};

type LocNameStart = 'SPCandidateSystemActivityMerges';
export type SPCandidateSystemActivityMergesLocNames =
	| `${LocNameStart}TitlePage`
	| `${LocNameStart}TitleTab`
	| `${LocNameStart}ButtonViewDetails`
	| `${LocNameStart}LabelMergeId`
	| `${LocNameStart}LabelMergeDate`
	| `${LocNameStart}LabelApprovedBy`
	| `${LocNameStart}LabelWinners`
	| `${LocNameStart}LabelLosers`
	| `${LocNameStart}LabelDetails`;

export const spCandidateSystemActivityMergesLocs: LocDefs<SPCandidateSystemActivityMergesLocNames> =
	{
		SPCandidateSystemActivityMergesTitlePage: {
			defaultValue: 'Merges',
			description: 'Page title',
			displayPath: `${pathStart}Page title`,
			displayType: 'Title',
			legacyName: 'MergeCandidates/Candidates.SystemActivity.Merges.Title.Merges',
			...sharedProperties,
		},
		SPCandidateSystemActivityMergesTitleTab: {
			defaultValue: 'Candidate Merges',
			description: 'Tab title',
			displayPath: `${pathStart}Tab title`,
			displayType: 'Title',
			legacyName: 'MergeCandidates/Candidates.SystemActivity.Merges.Title.PageTitle',
			...sharedProperties,
		},
		SPCandidateSystemActivityMergesButtonViewDetails: {
			defaultValue: 'View Details',
			description: 'View Details button',
			displayPath: `${pathStart}View Details`,
			displayType: 'Button',
			legacyName: 'MergeCandidates/Candidates.SystemActivity.Merges.Content.ViewDetails',
			...sharedProperties,
		},
		SPCandidateSystemActivityMergesLabelMergeId: {
			defaultValue: 'Merge ID',
			description: 'Column heading for: Merge ID.',
			displayPath: `${pathStart}Merge ID`,
			displayType: 'Label',
			legacyName: 'MergeCandidates/Candidates.SystemActivity.Merges.ColumnHeading.MergeID',
			...sharedProperties,
		},
		SPCandidateSystemActivityMergesLabelMergeDate: {
			defaultValue: 'Merge Date',
			description: 'Column heading for: Merge Date.',
			displayPath: `${pathStart}Merge Date`,
			displayType: 'Label',
			legacyName: 'MergeCandidates/Candidates.SystemActivity.Merges.ColumnHeading.MergeDate',
			...sharedProperties,
		},
		SPCandidateSystemActivityMergesLabelApprovedBy: {
			defaultValue: 'Approved By',
			description: 'Column heading for: Approved By.',
			displayPath: `${pathStart}Approved By`,
			displayType: 'Label',
			legacyName: 'MergeCandidates/Candidates.SystemActivity.Merges.ColumnHeading.ApprovedBy',
			...sharedProperties,
		},
		SPCandidateSystemActivityMergesLabelWinners: {
			defaultValue: 'Winners',
			description: 'Column heading for: Winners.',
			displayPath: `${pathStart}Winners`,
			displayType: 'Label',
			legacyName: 'MergeCandidates/Candidates.SystemActivity.Merges.ColumnHeading.Winners',
			...sharedProperties,
		},
		SPCandidateSystemActivityMergesLabelLosers: {
			defaultValue: 'Losers',
			description: 'Column heading for: Losers.',
			displayPath: `${pathStart}Losers`,
			displayType: 'Label',
			legacyName: 'MergeCandidates/Candidates.SystemActivity.Merges.ColumnHeading.Losers',
			...sharedProperties,
		},
		SPCandidateSystemActivityMergesLabelDetails: {
			defaultValue: 'Details',
			description: 'Column heading for: Details.',
			displayPath: `${pathStart}Details`,
			displayType: 'Label',
			legacyName: 'MergeCandidates/Candidates.SystemActivity.Merges.ColumnHeading.Details',
			...sharedProperties,
		},
	};

export type SPCandidateSystemActivityMergesLocType =
	LocMap<SPCandidateSystemActivityMergesLocNames>;
